// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 4329) return "static/chunks/4329.4092b6296c9a1176.js";
	if (chunkId === 6888) return "static/chunks/6888.cb06882d090c35aa.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2379":"fd847850","3043":"1ce67c87","4946":"29b90a71"}[chunkId] || chunkId) + "-" + {"2379":"01758070d7c415ec","3043":"d9aa929aa9a42608","3327":"a8a134ef46ebf18f","4946":"e8108137ee127704"}[chunkId] + ".js";
};